class ProductList extends HTMLElement {
  constructor(){ super(); }

  connectedCallback(){
    this.initSlider();
    this.initATC();
  }

  initSlider(){
    this.swiper = new Swiper(this.querySelector('.swiper-product-list'), {
      slidesPerView: 1.4,
      spaceBetween: 6,
      initialSlide: 1,
      centeredSlides: false,
      breakpoints: {
        700: { slidesPerView: 2.5, spaceBetween: 12 },
        989: { slidesPerView: 4, spaceBetween: 18, centeredSlides: false }
      }
    });
  }

  initATC(){
    const openDrawerNow = () => {
      const d = document.querySelector('cart-drawer');
      if (d && typeof d.open === 'function') { d.open(); return; }
      const t = document.querySelector('[data-cart-trigger], [data-drawer-toggle="cart"], button[aria-controls="CartDrawer"], .header__icon--cart');
      if (t) { t.click(); }
    };

    const refreshSections = async () => {
      const res = await fetch(`/?sections=cart-drawer,cart-icon-bubble`, { headers: { 'Accept':'application/json' }});
      const json = await res.json();
      const wrap = document.createElement('div');

      if (json['cart-icon-bubble']) {
        const bubbleTarget = document.querySelector('#cart-icon-bubble, .cart-icon-bubble');
        wrap.innerHTML = json['cart-icon-bubble'];
        const bubbleNew = wrap.firstElementChild;
        if (bubbleTarget && bubbleNew) bubbleTarget.replaceWith(bubbleNew);
        wrap.innerHTML = '';
      }

      if (json['cart-drawer']) {
        const oldDrawer = document.querySelector('cart-drawer');
        wrap.innerHTML = json['cart-drawer'];
        const newDrawer = wrap.querySelector('cart-drawer');
        if (oldDrawer && newDrawer) oldDrawer.replaceWith(newDrawer);
        wrap.innerHTML = '';
      }

      requestAnimationFrame(openDrawerNow);
    };

    this.addEventListener('click', async (e)=>{
      const btn = e.target.closest('.js-pl-add[data-variant-id]');
      if (!btn) return;

      const id = btn.dataset.variantId;
      if (!id) return;

      btn.disabled = true;

      try{
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
          body: JSON.stringify({ id, quantity: 1 })
        });
        if (!r.ok) throw new Error('add failed');
        await refreshSections();
      }catch(err){
        console.error(err);
      }finally{
        btn.disabled = false;
      }
    });
  }
}

customElements.define('product-list', ProductList);
